import { useState } from 'react';
import { useDeleteExpense } from '../../api/useDeleteExpense';

type Props = {
  expenseId: string;
};

export function useExpenseMenuAction(props: Props) {
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const { mutateAsync } = useDeleteExpense();

  return {
    isEditOpen,
    isDeleteOpen,
    handleOpenEdit: () => setIsEditOpen(true),
    handleCloseEdit: () => setIsEditOpen(false),
    handleOpenDelete: () => setIsDeleteOpen(true),
    handleCloseDelete: () => setIsDeleteOpen(false),
    handleConfirmDelete: () => mutateAsync(props.expenseId),
  };
}
